// Modules
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import showdown from 'showdown';

import { Page, PageContent, PageHeader } from 'components/page';
import Person from 'services/data/person';

import CHANGELOG from '../../../CHANGELOG.md';

const converter = new showdown.Converter();


// Component
class ViewPortalChanges extends React.Component {
  static propTypes = {
    currentUser: PropTypes.object
  };

  componentDidMount() {
    const { currentUser } = this.props;

    Person.update({ id: currentUser.id, hasViewedLatestPortalChanges: true });
  }

  shouldComponentUpdate() {
    // Never update this page
    return false;
  }

  render() {
    const { currentUser } = this.props;

    return (
      <Page className="changes-page">
        <PageHeader title="Portal Updates" />
        <PageContent className={classNames('changelog', { 'has-new-changes': !currentUser.hasViewedLatestPortalChanges })}>
          <div className="app-urls">
            <div dangerouslySetInnerHTML={{ __html: converter.makeHtml(CHANGELOG) }} />
          </div>
        </PageContent>
      </Page>
    );
  }
}

export default connect((state) => ({
  currentUser: state.auth.currentUser
}))(ViewPortalChanges);



// WEBPACK FOOTER //
// ./app/routes/settings/view-portal-changes.js